export const LOCAL_STORAGE_KEY_IS_LOGGED_IN = "local_storage_key_is_logged_in"
export const LOCAL_STORAGE_KEY_TOKEN = "local_storage_key_token"
export const LOCAL_STORAGE_KEY_ERP_USER_NAME = "local_storage_key_erp_user_name"
export const LOCAL_STORAGE_KEY_ERP_USER_ID = "local_storage_key_erp_user_id"
